module.exports = __webpack_public_path__ + "static/media/La-nueva-contabilidad-banner.33f1793e.jpg";